import { useState } from 'react';
import { usePrincipal } from '@/lib/auth/use-auth';
import { Button, FormField, Select, TextInput, toast } from '@/lib/ui';
import type { Company, SpecialHandlingNote } from '@shared/types';
import { saveSpecialHandling } from './api';

const SEVERITIES: SpecialHandlingNote['severity'][] = ['info', 'warning', 'critical'];
const badge = (s: SpecialHandlingNote['severity']) => (s === 'critical' ? 'badge-cancelled' : s === 'warning' ? 'badge-inprogress' : 'badge-blue');

export function SpecialHandlingEditor({ company, canEdit }: { company: Company; canEdit: boolean }) {
  const me = usePrincipal();
  const [text, setText] = useState('');
  const [severity, setSeverity] = useState<SpecialHandlingNote['severity']>('info');
  const save = (notes: SpecialHandlingNote[]) => saveSpecialHandling(company.id, notes, me).then(() => toast.success('Special handling updated'));
  const notes = company.specialHandlingNotes;
  return (
    <div className="card">
      <div className="card-header"><span className="card-title">Special handling notes</span></div>
      <div className="card-body">
        {notes.map((n, i) => (
          <div key={i} className="settings-row" style={{ opacity: n.active ? 1 : 0.5 }}>
            <div><span className={`badge ${badge(n.severity)}`}>{n.severity}</span> {n.text}</div>
            {canEdit ? (
              <span>
                <Button size="sm" variant="ghost" onClick={() => save(notes.map((x, j) => (j === i ? { ...x, active: !x.active } : x)))}>{n.active ? 'Deactivate' : 'Activate'}</Button>
                <Button size="sm" variant="ghost" onClick={() => save(notes.filter((_, j) => j !== i))}>Delete</Button>
              </span>
            ) : null}
          </div>
        ))}
        {canEdit ? (
          <>
            <FormField label="New note" htmlFor="sh-text"><TextInput id="sh-text" value={text} onChange={(e) => setText(e.target.value)} /></FormField>
            <FormField label="Severity" htmlFor="sh-sev"><Select id="sh-sev" value={severity} onChange={(e) => setSeverity(e.target.value as SpecialHandlingNote['severity'])} options={SEVERITIES.map((s) => ({ value: s, label: s }))} /></FormField>
            <Button size="sm" variant="primary" disabled={!text.trim()} onClick={() => { void save([...notes, { text: text.trim(), severity, active: true }]); setText(''); }}>Add note</Button>
          </>
        ) : null}
      </div>
    </div>
  );
}
